import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { configBonusHandle, configGradeList } from '@/api/apis';
export default {
  props: {
    gradeList: {
      required: true
    },
    levelList: {
      required: true
    }
  },
  data: function data() {
    return {
      conditions: []
    };
  },
  watch: {
    gradeList: function gradeList(newVal, oldVal) {
      this.conditions = [];

      for (var item in this.gradeList) {
        var cond = JSON.parse(item.conditions);
        this.conditions.push({
          name: item.name,
          gradeId: item.id,
          level: cond.level,
          pov: cond.pov,
          market_num: cond.market_num,
          market_pov: cond.market_pov,
          market_grade: cond.market_grade
        });
      }
    }
  },
  mounted: function mounted() {
    this.conditions = JSON.parse(this.bonusData.conditions);
    console.log('this.conditions', this.conditions);
  },
  methods: {
    clickSave: function clickSave() {
      var _this = this;

      configBonusHandle({
        id: this.bonusData.id,
        conditions: JSON.stringify(this.conditions)
      }).then(function _callee(res) {
        return regeneratorRuntime.async(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$alert('保存成功', '提示', {
                  confirmButtonText: '确定'
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        });
      });
    }
  }
};